import script from "./BaseEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseEditor.vue?vue&type=script&setup=true&lang=js"

import "./BaseEditor.vue?vue&type=style&index=0&id=bdfb24cc&lang=css"

const __exports__ = script;

export default __exports__